import {
    MessageCircle,
    Plane,
    Briefcase,
    Headphones,
    Heart,
    TrendingUp,
} from "lucide-react";

const benefits = [
    {
        icon: MessageCircle,
        title: "Falar sem travar",
        desc: "Sair da paralisia mental e conseguir manter uma conversa real, sem traduzir tudo na cabeça.",
    },
    {
        icon: Plane,
        title: "Viajar sem medo",
        desc: "Pedir, perguntar, negociar e se relacionar em qualquer país — sem depender de tradutor.",
    },
    {
        icon: Briefcase,
        title: "Destravar a carreira",
        desc: "Aplicar para vagas internacionais, reuniões em inglês e promoções que pagam 60% a mais.",
    },
    {
        icon: Headphones,
        title: "Entender o que ouve",
        desc: "Compreender filmes, séries, podcasts e nativos falando rápido, sem legenda.",
    },
    {
        icon: Heart,
        title: "Recuperar a confiança",
        desc: "Parar de se sentir burro por algo que nunca foi sua culpa — e finalmente se orgulhar.",
    },
    {
        icon: TrendingUp,
        title: "Resultado em 30 dias",
        desc: "Plano prático, dia a dia, 30 minutos por dia. Sem milagre. Só método.",
    },
];

export default function Benefits() {
    return (
        <section
            id="benefits"
            data-testid="section-benefits"
            className="bg-cream py-24 lg:py-32"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
                <div className="max-w-3xl reveal">
                    <div className="flex items-center gap-3 mb-5">
                        <span className="hairline w-10" />
                        <span className="label-eyebrow">O que muda</span>
                    </div>
                    <h2 className="font-serif text-emerald-brand text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tight">
                        O que acontece quando seu inglês{" "}
                        <span className="italic text-gold-brand">destrava</span>
                        .
                    </h2>
                    <p className="mt-5 text-lg text-emerald-light/85 leading-relaxed">
                        Não são funcionalidades. São transformações reais — na
                        sua boca, na sua mente e na sua vida.
                    </p>
                </div>

                <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {benefits.map((b, i) => {
                        const Icon = b.icon;
                        return (
                            <div
                                key={i}
                                className="reveal group bg-white border-t-2 border-t-gold-brand border border-cream rounded-2xl p-7 hover:-translate-y-1 transition-transform"
                                data-testid={`benefit-${i}`}
                            >
                                <div className="w-12 h-12 rounded-xl bg-emerald-brand/5 flex items-center justify-center mb-5">
                                    <Icon className="w-6 h-6 text-emerald-brand" />
                                </div>
                                <h3 className="font-serif text-emerald-brand text-2xl leading-tight">
                                    {b.title}
                                </h3>
                                <p className="mt-3 text-emerald-light/85 leading-relaxed">
                                    {b.desc}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
